import { render } from "./PlaylistDetails.vue?vue&type=template&id=3ef72384&scoped=true"
import script from "./PlaylistDetails.vue?vue&type=script&lang=js"
export * from "./PlaylistDetails.vue?vue&type=script&lang=js"

import "./PlaylistDetails.vue?vue&type=style&index=0&id=3ef72384&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef72384"]])

export default __exports__